import { render, staticRenderFns } from "./readeCourseOffice.vue?vue&type=template&id=1cf9391e"
import script from "./readeCourseOffice.vue?vue&type=script&lang=js"
export * from "./readeCourseOffice.vue?vue&type=script&lang=js"
import style0 from "./readeCourseOffice.vue?vue&type=style&index=0&id=1cf9391e&prod&lang=css"


/* normalize component */
import normalizer from "!../../zm_teacher/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports